<template>
  <div>
    <SaveInfo
      :isDataUpdating="isDataUpdating"
    ></SaveInfo>
    <div v-if="!isLoading && project !== null">
      <div class="content_block_top_label">
        <p v-if="selectedCompetition?.name">Текущий выбранный конкурс: <strong>{{ selectedCompetition.name }}</strong></p>
        <p v-if="selectedCompetition?.name" style="margin: 30px 0;"><a class="button2" style=" border: 2px solid #F69F22;" @click.prevent="showModal">Подать заявку на конкурс</a></p>
          <p v-else style="margin: 30px 0;"><a class="button2" style=" border: 2px solid #F69F22;" @click.prevent="showModal">Перейти к отправке на конкурсы</a></p>
        <p style="margin-bottom: 30px;">Чтобы подать проект на конкурс пройдите в раздел нужного вам конкурса и нажмите "Подать заявку"</p>
      </div>
<!--      <div class="tabs">-->
<!--        <ul>-->
<!--          <li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Информация о проекте</a></li>-->
<!--          <li @click="changeCurrentTab(2)" class="tab" :class="tabNum === 2 ? 'is-active' : ''"><a>Технологический фокус</a></li>-->
<!--        </ul>-->
<!--      </div>-->
      <form id="project_form" enctype="multipart/form-data">
        <div class="errors-block" v-if="errors.length">
          <b>Пожалуйста, заполните поля:</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
          </ul>
        </div>
        <div id="tabContent">
          <div v-if="tabNum === 1" id="tab1" class="content-tab">
            <div class="columns">
              <div class="column">

                <p><strong>Информация о заявителе</strong></p>

                <BaseInput
                    label="Фамилия"
                    v-model="project.project_data.lastname"
                    objectKey="lastname"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Имя"
                    v-model="project.project_data.firstname"
                    objectKey="firstname"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Отчество"
                    v-model="project.project_data.surname"
                    objectKey="surname"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Электронная почта"
                    v-model="project.project_data.email"
                    objectKey="email"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Контактный телефон"
                    v-model="project.project_data.phone"
                    objectKey="phone"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <p><strong>Информация о проекте</strong></p>

                <BaseInput
                  label="Юридическое лицо (если зарегистрировано)"
                  v-model="project.project_data.yurlitso"
                  objectKey="yurlitso"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
                  @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Полное фирменное наименование юридического лица (если зарегистрировано)"
                    v-model="project.project_data.yurlitsofull"
                    objectKey="yurlitsofull"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="ИНН (организации)"
                    v-model="project.project_data.yurlitsoinn"
                    objectKey="yurlitsoinn"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <SearchAutocompleteCities
                    :items="citiestoinput"
                    ref="predpolCityAutocomlete"
                    v-model="project.city"
                    label="Город, где работает команда"
                    objectKey="city"
                    parentKey="project"
                    :isDataUpdating="isDataUpdating"
                >
                </SearchAutocompleteCities>

                <BaseInput
                    label="Название проекта"
                    v-model="project.name"
                    objectKey="name"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

<!--                <BaseTextarea-->
<!--                    label="Направление (новое технологическое решение, программное приложение, база данных и.т.д.)"-->
<!--                    v-model="project.project_data.napravlenie"-->
<!--                    objectKey="napravlenie"-->
<!--                    :isDataUpdated="isDataUpdating"-->
<!--                    :isFormSubmitted="isSubmitted"-->
<!--                    @onChange="saveData"-->
<!--                ></BaseTextarea>-->

                <div class="field">
                  <label :class="this.isFieldRequired('napravlenie') ? 'req': ''">Направление проекта</label>
                  <p><a target="_blank" href="https://disk.yandex.ru/i/OHQmO0JwocyoTw">Уточнение направлений проектов тут</a></p>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="napravlenie1" value="Программный проект в области производства контента" v-model="project.project_data.napravlenie">
                    <label for="napravlenie1">Программный проект в области производства контента</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="napravlenie2" value="Программные проекты в области медиапотрепления" v-model="project.project_data.napravlenie">
                    <label for="napravlenie2">Программные проекты в области медиапотрепления</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="napravlenie3" value="Новое оборудование для киноиндустрии" v-model="project.project_data.napravlenie">
                    <label for="napravlenie3">Новое оборудование для киноиндустрии</label>
                  </div>

                  <BaseInput
                      label="Иные технологии и проекты для киноиндустрии, отличные от вышеуказанных, (написать)"
                      v-model="project.project_data.napravlenie_input"
                      objectKey="napravlenie_input"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      @onChange="saveData"
                  ></BaseInput>

<!--                  <div>-->
<!--                    <label>Иные технологии и проекты для киноиндустрии, отличные от вышеуказанных, (написать)</label>-->
<!--                    <input class="input" v-model="napravlenieField" type="text">-->
<!--                  </div>-->
                </div>

<!--                <div class="field">-->
<!--                  <label :class="this.isFieldRequired('napravlenie') ? 'req': ''">Направление проекта</label>-->
<!--                  <p><a target="_blank" href="https://disk.yandex.ru/i/OHQmO0JwocyoTw">Уточнение направлений проектов тут</a></p>-->
<!--                  <div class="select-field">-->
<!--                    <select :disabled="isDataUpdating" @change="saveData" v-model="project.project_data.napravlenie">-->
<!--                      <option value="Программный проект в области производства контента">Программный проект в области производства контента</option>-->
<!--                      <option value="Программные проекты в области медиапотрепления">Программные проекты в области медиапотрепления</option>-->
<!--                      <option value="Иные технологии и проекты для киноиндустрии, отличные от вышеуказанных">Иные технологии и проекты для киноиндустрии, отличные от вышеуказанных</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->

                <BaseTextarea
                    label="Краткое описание проекта"
                    v-model="project.annotation"
                    objectKey="annotation"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseTextarea>

                <BaseTextarea
                    label="Обоснование актуальности проекта"
                    v-model="project.project_data.actual_obosn"
                    objectKey="actual_obosn"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseTextarea>

                <Field v-model="project.project_data.website" name="project.project_data.website" v-slot="{ field, errorMessage }" :rules="isValidUrl">
                  <BaseInput
                      label="Веб-сайт проекта (ссылка, если есть)"
                      ref="siteField"
                      v-bind="field"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :class="errorMessage ? 'has_errors' : ''"
                      @onChange="saveData"
                  ></BaseInput>
                  <BaseErrorMessage id="1">
                    {{ errorMessage }}
                  </BaseErrorMessage>
                </Field>

                <TinymceEditor
                    label="Полное описание проекта (до 5 тыс. символов)"
                    id="full_description"
                    max_chars="5000"
                    :value="project.project_data.full_description"
                    parentKey="project_data"
                    objectKey="full_description"
                    :isDataUpdating="isDataUpdating"
                ></TinymceEditor>

                <div class="field">
                  <label :class="this.isFieldRequired('level_development') ? 'req': ''">Уровень готовности технологии вашего проекта (УГТ - выбор из выпадающего списка)</label>
                  <p><a href="https://disk.yandex.ru/i/7hltZMqBLKPLVg" target="_blank">Таблица определения УГТ тут</a></p>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development1" value="Даны расчеты и экспериментальные подтверждения по важнейшим характеристикам проекта (УГТ-3)" v-model="project.project_data.level_development">
                    <label for="level_development1">Даны расчеты и экспериментальные подтверждения по важнейшим характеристикам проекта (УГТ-3)</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development2" value="Компоненты и/или макеты проекта проверены в лабораторных условиях (УГТ-4)" v-model="project.project_data.level_development">
                    <label for="level_development2">Компоненты и/или макеты проекта проверены в лабораторных условиях (УГТ-4)</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development3" value="Компоненты и/или макеты проекта верифицированы в условиях, близких к реальным (УГТ-5)" v-model="project.project_data.level_development">
                    <label for="level_development3">Компоненты и/или макеты проекта верифицированы в условиях, близких к реальным (УГТ-5)</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development4" value="Модель или прототип проекта продемонстрированы в условиях, близких к реальным (УГТ-6)" v-model="project.project_data.level_development">
                    <label for="level_development4">Модель или прототип проекта продемонстрированы в условиях, близких к реальным (УГТ-6)</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development5" value="Прототип системы прошел демонстрацию в эксплуатационных условиях (УГТ-7)" v-model="project.project_data.level_development">
                    <label for="level_development5">Прототип системы прошел демонстрацию в эксплуатационных условиях (УГТ-7)</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development6" value="Создан полностью рабочий прототип проекта и освидетельствован (квалифицирован) в реальных условиях посредством испытаний и демонстраций (УГТ-8)" v-model="project.project_data.level_development">
                    <label for="level_development6">Создан полностью рабочий прототип проекта и освидетельствован (квалифицирован) в реальных условиях посредством испытаний и демонстраций (УГТ-8)</label>
                  </div>
                    <div class="checkbox__wrapper">
                    <input type="checkbox" @change="saveData" id="level_development7" value="Продемонстрирована работа реальной системы в условиях реальной эксплуатации (УГТ-9)" v-model="project.project_data.level_development">
                    <label for="level_development7">Продемонстрирована работа реальной системы в условиях реальной эксплуатации (УГТ-9)</label>
                  </div>

<!--                  <BaseInput-->
<!--                      label="Иные технологии и проекты для киноиндустрии, отличные от вышеуказанных, (написать)"-->
<!--                      v-model="project.project_data.level_development_input"-->
<!--                      objectKey="napravlenie_input"-->
<!--                      :isDataUpdated="isDataUpdating"-->
<!--                      :isFormSubmitted="isSubmitted"-->
<!--                      @onChange="saveData"-->
<!--                  ></BaseInput>-->



<!--                  <label :class="this.isFieldRequired('level_development') ? 'req': ''">Уровень готовности технологии вашего проекта (УГТ - выбор из выпадающего списка)</label>-->
<!--                  <p><a href="https://disk.yandex.ru/i/7hltZMqBLKPLVg" target="_blank">Таблица определения УГТ тут</a></p>-->
<!--                  <div class="select-field">-->
<!--                    <select :disabled="isDataUpdating" @change="saveData" v-model="project.project_data.level_development">-->
<!--                      <option value="Даны расчеты и экспериментальные подтверждения по важнейшим характеристикам проекта (УГТ-3)">Даны расчеты и экспериментальные подтверждения по важнейшим характеристикам проекта (УГТ-3)</option>-->
<!--                      <option value="Компоненты и/или макеты проекта проверены в лабораторных условиях (УГТ-4)">Компоненты и/или макеты проекта проверены в лабораторных условиях (УГТ-4)</option>-->
<!--                      <option value="Компоненты и/или макеты проекта верифицированы в условиях, близких к реальным (УГТ-5)">Компоненты и/или макеты проекта верифицированы в условиях, близких к реальным (УГТ-5)</option>-->
<!--                      <option value="Модель или прототип проекта продемонстрированы в условиях, близких к реальным (УГТ-6)">Модель или прототип проекта продемонстрированы в условиях, близких к реальным (УГТ-6)</option>-->
<!--                      <option value="Прототип системы прошел демонстрацию в эксплуатационных условиях (УГТ-7)">Прототип системы прошел демонстрацию в эксплуатационных условиях (УГТ-7)</option>-->
<!--                      <option value="Создан полностью рабочий прототип проекта и освидетельствован (квалифицирован) в реальных условиях посредством испытаний и демонстраций (УГТ-8)">Создан полностью рабочий прототип проекта и освидетельствован (квалифицирован) в реальных условиях посредством испытаний и демонстраций (УГТ-8)</option>-->
<!--                      <option value="Продемонстрирована работа реальной системы в условиях реальной эксплуатации (УГТ-9)">Продемонстрирована работа реальной системы в условиях реальной эксплуатации (УГТ-9)</option>-->
<!--                    </select>-->
<!--                  </div>-->
                </div>

                <TinymceEditor
                    label="Описание бизнес модели/плана реализации проекта (до 5 тыс. символов)"
                    id="bizness_plan"
                    max_chars="5000"
                    :value="project.project_data.bizness_plan"
                    parentKey="project_data"
                    objectKey="bizness_plan"
                    :isDataUpdating="isDataUpdating"
                ></TinymceEditor>

              </div>
              <div class="column">
                <BaseTextarea
                    label="Укажите всех, кто обладает исключительными правами или имеет какие-либо иные права на заявляемый проект (соавторы, соучредители, инвесторы и т.п.)"
                    v-model="project.project_data.rights_on_project"
                    objectKey="rights_on_project"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseTextarea>

                <BaseTextarea
                    label="Потенциальный эффект при внедрении Вашего решения/продукта"
                    v-model="project.project_data.potential_effect"
                    objectKey="potential_effect"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseTextarea>

                <BaseTextarea
                    label="Ожидаемый эффект при внедрении Вашего решения/продукта"
                    v-model="project.project_data.ozhidaemii_effect"
                    objectKey="ozhidaemii_effect"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseTextarea>

                <div class="field">
                  <label :class="this.isFieldRequired('needed_resourses') ? 'req': ''">Необходимые ресурсы для реализации проекта</label>
                  <div id="project_zhanr">
                      <div class="checkbox__wrapper">
                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_0"
                           value="Финансовые" v-model="project.project_data.needed_resourses">
													<label for="project_zhanr_0">Финансовые</label></div>
                      <div class="checkbox__wrapper">
                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_1"
                           value="Материальные" v-model="project.project_data.needed_resourses">
													<label for="project_zhanr_1">Материальные</label></div>
                      <div class="checkbox__wrapper">
                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_2"
                           value="Административные" v-model="project.project_data.needed_resourses">
                    <label for="project_zhanr_2">Административные</label>
											</div>
                      <div class="checkbox__wrapper">
                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_3"
                           value="Организационные" v-model="project.project_data.needed_resourses">
													<label for="project_zhanr_3">Организационные</label></div>
                      <div class="checkbox__wrapper">
                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_4"
                           value="Экспертные" v-model="project.project_data.needed_resourses">
													<label for="project_zhanr_4">Экспертные</label></div>
                      <div class="checkbox__wrapper">
                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_5"
                           value="Информационные" v-model="project.project_data.needed_resourses">
													<label for="project_zhanr_5">Информационные</label></div>
                  </div>
                  <BaseInput
                      label="другое, (написать)"
                      v-model="project.project_data.needed_resourses_other"
                      objectKey="needed_resourses_other"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      @onChange="saveData"
                  ></BaseInput>
                </div>

                <BaseInput
                    label="Укажите потребности в инвестициях (при необходимости), в рублях"
                    v-model="project.project_data.investisii"
                    objectKey="investisii"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseInput>

                <BasePdfUploader
                    :project="project"
                    :value="project.project_data.presentation_about"
                    :currentProjectId="currentProjectId"
                    label="Презентация проекта"
                    description="<a target='_blank' href='https://disk.yandex.ru/i/D1M2_SU08IC9iA'>Шаблон презентации</a>. Настоятельно рекомендуем использовать шаблон при оформлении заявки. Если вы используете свой дизайн презентации, необходимо отразить в своей презентации все обязательные разделы, отраженные в шаблоне (PDF лимит 25 МБ)"
                    pathToUpload="/project/uploadProjectSimple/"
                    objectKey="presentation_about"
                    isTransKey=true
                ></BasePdfUploader>

                <BaseTextarea
                    label="Дополнительная информация"
                    v-model="project.additional_info"
                    objectKey="additional_info"
                    :isDataUpdated="isDataUpdating"
                    :isFormSubmitted="isSubmitted"
                    @onChange="saveData"
                ></BaseTextarea>
              </div>
            </div>
          </div>
<!--          <div v-if="tabNum === 2" class="content-tab">-->
<!--            <div class="columns">-->
<!--              <div class="column">-->
<!--                <div class="tab_block">-->
<!--                    <div class="columns">-->
<!--                      <div class="column left_column">-->

<!--                      </div>-->
<!--                      <div class="column"></div>-->
<!--                    </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <p>Информация введенная в поля анкеты сохраняется автоматически.</p>
      </form>
    </div>
    <div v-else>
      <BaseLoader></BaseLoader>
    </div>

    <Modal
      v-model="isShow"
      :close="closeModal"
    >
      <template v-if="competitionMode">
        <div class="modal">
        <i @click="closeModal" class="fas fa-times-circle close_button"></i>
        <div v-if="selectedCompetitionId === 0">
          <h1 style="margin-bottom: 85px;">Конкурсы</h1>
          <template v-if="isLoading">
            <BaseLoader></BaseLoader>
          </template>
          <template v-else>
            <div class="columns is-multiline">
              <div v-for="(competition, index) in competitions" :class="index % 2 === 0 ? 'col1' : 'col2'"
                   class="column competition_wrapper is-5-desktop" :data-competitionid="competition.id"
                   :key="competition.id">
                <div class="competition_wrapper_inner" style="position: relative">
                  <div class="competition-image-wrapper">
                    <img class="competition_image" :src="competition.clearAvatar">
                  </div>
                  <div class="competiton_order_button_div">
                    <a @click="setCompetitionId(competition.id);" class="button2 competiton_order_button">Подать заявку</a>
                  </div>
                </div>

                <div class="competition-info">
                  <p class="competition-type">{{ competition.napravlenie }}</p>
                  <p class="competition-title__wrapper"><a class="competition-title"
                                                           :href="'/competition/single/' + competition.id">{{
                      competition.name
                    }}</a></p>
                </div>

                <div class="competition_do">
                  ДО<br>
                  {{ formatCompetitionDate(competition.endDate) }}
                </div>
              </div>
            </div>
            <Pagination
                perPage=10
                @updateParentData="loadCompetitions"
                :totalItems="totalCompetitions"
                :currentPageNum="currentPageNum"
            ></Pagination>
          </template>
        </div>
        <div class="choise_category" v-else>
          <p v-if="windowCompetitionId.length === 0"><a @click="selectedCompetitionId = 0">Выбрать другой конкурс</a>
          </p>
          <h1 v-if="errors.length === 0">Выберите категорию конкурса {{ selectedCompetition?.name }}</h1>
          <div v-if="isLoading">
            <div class="lds-default">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div v-else>
            <div class="errors-block" v-if="errors.length">
              <b style="color:#000;">Для этого конкурса нужно заполнить следующие поля:</b>
              <ul>
                <li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
              </ul>
              <p><a @click="closeModal">Заполнить поля</a></p>
            </div>
            <div v-else>
              <p class="category_select"
                 :class="category.isProjectInfoSubmitted === '1' ? 'category_select_active' : ''"
                 @click="makeProjectInfo(category.id, category.isProjectInfoSubmitted)"
                 v-for="category in selectedCompetition?.categories" :key="category.id"><i
                  v-if="category.isProjectInfoSubmitted === '1'" style="color: green; margin-right: 10px;"
                  class="fas fa-check-square"></i> {{ category.name }} <span
                  v-if="category.isProjectInfoSubmitted === '1'">(Заявка подана)</span></p>
            </div>
          </div>
        </div>
      </div></template>
      <template v-if="questionMode">
        <div class="modal modal_question">
          <QuestionText1></QuestionText1>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import BasePdfUploader from "./Base/BasePdfUploader";
import BaseErrorMessage from "./Base/BaseErrorMessage";
import 'cropperjs/dist/cropper.css';
import BaseInput from "./Base/BaseInput3";
import BaseTextarea from "./Base/BaseTextarea";
import SaveInfo from "./Base/SaveInfo";
import TinymceEditor from "./Base/TinymceEditor";
import moment from 'moment';
import Pagination from "./Base/PaginationComponent";
import SearchAutocompleteCities from "./Base/SearchAutocompleteCitiesSingle";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import QuestionText1 from "./Base/QuestionText1";
import BaseLoader from "./Base/BaseLoader";
import { Field } from 'vee-validate';

library.add(faQuestion);

export default {
  name: 'MainComponent',
  data() {
    return {
      project: null,
      countriesinput: [],
      selected_country: '',
      citiestoinput: [],
      imgSrc: '',
      country: 'Российская Федерация',
      origfilename: '',
      tabNum: 1,
      currentCommand: [],
      errors: [],
      //napravlenieField: "",
      isLoading: true,
      isSubmitted: false,
      isDataUpdating: false,
      validationRules: [],
      competitions: [],
      totalCompetitions: 0,
      isShow: false,
      selectedCompetitionId: 0,
      currentPageNum: 0,
      isUserFillProfile: false,
      competitionMode: false,
      questionMode: false,
    }
  },
  components: {
    BasePdfUploader,
    BaseLoader,
    BaseInput,
    TinymceEditor,
    Pagination,
    SaveInfo,
    BaseErrorMessage,
    SearchAutocompleteCities,
    //FontAwesomeIcon,
    QuestionText1,
    BaseTextarea,
    Field
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
    this.checkIsUserFillProfile().then(() => {
      //Если выбран активный конкурс, куда подается заявка.
      if (window.competitionId?.length > 0) {
        this.selectedCompetitionId = window.competitionId;
        this.loadCompetition(this.selectedCompetitionId);
        if (window.new.length > 0) {
          this.getData(false, false);
        } else {
          this.getData(true, true);
        }
      } else {
        //Если после добавления нового проекта
        if (window.new.length > 0) {
          this.getData(false);
        } else {
          this.getData()
        }
        this.loadCompetitions(1);
      }
    });
  },
  watch: {
    // napravlenieField(newValue, oldValue) {
    //   console.log(newValue, oldValue);
    //   const index = this.project.project_data.napravlenie.indexOf(oldValue);
    //   if (newValue.length > 0) {
    //     if(index !== -1)
    //     {
    //       this.project.project_data.napravlenie[index] = newValue;
    //     } else {
    //       this.project.project_data.napravlenie.push(newValue);
    //     }
    //   } else {
    //     console.log(index);
    //     this.project.project_data.napravlenie.slice(index, 1)
    //   }
    // }
  },
  computed: {
    totalPages: function () {
      return Math.ceil(this.totalCompetitions / 10)
    },
    currentProjectId: function () {
      return window.projectId;
    },
    windowCompetitionId: function () {
      return window.competitionId;
    },
    isCountryFilled() {
      let res = false;
      if (this.project.country && this.project.country.length > 0) {
        res = true;
      }
      return res;
    },
    isCityFilled() {
      let res = false;
      if (this.project.city && this.project.city.length > 0) {
        res = true;
      }
      return res;
    },
    selectedCompetition() {
      return this.competitions.find(el => el.id === parseInt(this.selectedCompetitionId));
    }
  },
  methods: {
    async getData() {
      let project_data = {
        firstname: '',
        lastname: '',
        surname: '',
        email: '',
        phone: '',
        yurlitso: '',
        yurlitsofull: '',
        yurlitsoinn: '',
        website: '',
        actual_obosn: '',
        level_development: '',
        bizness_plan: '',
        rights_on_project: '',
        potential_effect: '',
        ozhidaemii_effect: '',
        needed_resourses: [],
        investisii: ''
      };

      const projectResponse = await axios.get('/api/projects/' + window.projectId, {
        headers: {
          'Accept': 'application/json',
        }
      })

      this.project = projectResponse.data;

      if (this.project.project_data === null || Array.isArray(this.project.project_data)) {
        this.project.project_data = {};
      }

      for (var key in project_data) {
        if (key === 'needed_resourses') {
          this.project.project_data[key] = projectResponse.data.project_data[key] ?? [];
        } else {
          this.project.project_data[key] = projectResponse.data.project_data[key] ?? '';
        }
      }

      if (this?.project?.project_data?.napravlenie !== undefined && !Array.isArray(this?.project?.project_data?.napravlenie)) {
        this.project.project_data.napravlenie = [];
      }

      if (this?.project?.project_data?.level_development !== undefined && !Array.isArray(this?.project?.project_data?.level_development)) {
        this.project.project_data.level_development = [];
      }


      if (this.citiestoinput.length === 0) {
        await this.loadCities();
      }
      this.isDataUpdating = false;

    },
    formatCompetitionDate(date) {
      return moment(date).format('M/D/YYYY')
    },
    showModal() {
      if (window.new.length > 0) {
        this.checkErrors()
      }
      this.isShow = true;
      this.competitionMode = true;
    },
    showModalQuestion() {
      this.isShow = true;
      this.questionMode = true;
    },
    closeModal() {
      this.isShow = false;
      this.competitionMode = false;
      this.questionMode = false;
    },
    loadCompetition(id) {
      const self = this;
      axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId, {
        headers: {
          'Accept': 'application/ld+json',
        }
      })
        .then(response => {
          self.competitions = [response.data];
          self.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadCompetitions(pageNum) {
      const self = this;
      this.currentPageNum = pageNum;
      self.isLoading = true;
      axios.get('/competition/apiGetCompetitions/' + window.projectId + '/' + pageNum, {
        headers: {
          'Accept': 'application/ld+json',
        }
      })
        .then(response => {
          self.isLoading = false;
          this.competitions = response.data['competitions'];
          this.totalCompetitions = response.data['total'];
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadCountries() {
      const self = this;
      axios.get('/get_all_countries', {
        headers: {
          'Accept': 'application/json',
        }
      })
        .then(response => {
          self.countriesinput = response.data;

        })
        .catch(error => {
          console.log(error);
        });
    },
    async loadCities() {
      await axios.get('/get_world_cities/RU', {
        headers: {
          'Accept': 'application/json',
        }
      }).then((response) => {
        this.citiestoinput = response.data;
      }).catch(error => {
        console.log(error);
      });
    },
    checkErrors(withScroll = true, showModal = false) {
      const self = this;
      this.isLoading = true;
      self.errors = [];

      this.validationRules.forEach(function (field) {
        self.validateField(field)
      });
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          self.validateField(field)
        });
        //this.errors.sort((a, b) => a.order > b.order ? 1 : -1);
      }

      if (!self.isUserFillProfile) {
        self.errors.unshift({
          text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/myprofile?check=true">https://script.moviestart.ru/myprofile</a>',
          order: '1'
        });
      }
      if (showModal) {
        self.showModal();
      }
      self.isLoading = false;
      if (withScroll && self.errors.length > 0) {
        if (document.getElementById("project_form")) {
          document.getElementById("project_form").scrollIntoView();
        }
      }

    },

    saveData: function () {
      const self = this;

      if (this.$refs.siteField.$attrs.class === 'has_errors') {
        return
      }

      if (!this.isDataUpdating) {
        this.isDataUpdating = true;

        axios.patch('/api/projects/' + window.projectId,
          {
            'name': this.project.name,
            'city': this.project.city,
            'annotation': this.project.annotation,
            'additionalInfo': this.project.additional_info,
            'projectData': this.project.project_data,
          },
          {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/merge-patch+json',
            }
          }
        ).then((response) => {
          if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
            alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
            window.location.reload();
          }
          if (self.isSubmitted) {
            self.checkErrors(false);
          }
          self.getData()
        }).catch(error => {
          console.log(error);
          alert('Ошибка получения данных')
        });
      }
    },
    regionClick() {
      if (!this.isCountryFilled) {
        alert("Заполните поле Страна");
        return;
      }
      if (!this.isCityFilled) {
        alert("Заполните поле Город");
      }

    },
    makeProjectInfo(categoryId, isProjectInfoSubmitted) {
      if (isProjectInfoSubmitted === '0') {
        this.isLoading = true;
        axios.get('/competition/apiAddProject/' + this.selectedCompetitionId + '/' + window.projectId + '/' + categoryId, {
          headers: {
            'Accept': 'application/ld+json',
          }
        })
          .then(response => {
            if (response.data['error']) {

              alert(response.data['error'])
            }
            if (window.competitionId?.length > 0) {
              this.loadCompetition(window.competitionId)
            } else {
              this.loadCompetitions(this.currentPageNum)
            }

          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Загрузить можно только изображение");
        return;
      }
      if (file.size > 1572864) {
        alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
        return;
      }
      this.origfilename = file.name;
      const self = this;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          self.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          if (self.$refs.cropper) {
            self.$refs.cropper.replace(event.target.result);
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      const self = this;
      this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
        let formData = new FormData();
        formData.append('file', blob);
        formData.append('original-name', self.origfilename);
        formData.append('current-name', self.project.afisha);

        formData.append('entity-id', self.project.id);

        axios(
          {
            method: 'post',
            url: '/project/getProjectAvatar',
            data: formData
          }
        )
          .then(() => {
            self.imgSrc = '';
            self.getData();
          });
      })
    },
    changeCurrentTab(num) {
      this.tabNum = num;
      document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
    },
    validateField(field) {
      const self = this;

      if (field.parentEntity !== undefined) {
        if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0))) {
          if (!self.errors.find(x => x.text === field.errorText)) {
            self.errors.push({
              text: field.errorText,
              order: field.order ? field.order : '1'
            });
          }
        }
      } else {
        if (field.isRequired && (self.project[field.fieldName] === null || self.project[field.fieldName].length === 0 || self.project[field.fieldName] === 0)) {
          if (!self.errors.find(x => x.text === field.errorText)) {
            self.errors.push({
              text: field.errorText,
              order: field.order ? field.order : '1'
            });
          }
        }
      }
    },
    checkIsUserFillProfile() {
      return new Promise((resolve, reject) => {
        const self = this;
        axios.get('/isUserFillProfile', {
          headers: {
            'Accept': 'application/json',
          }
        })
          .then(response => {
            self.isUserFillProfile = response.data;
            resolve(response.data)
          })
          .catch(error => {
            console.log(error);
            reject(error)
          });
      });
    },
    setCompetitionId(id) {
      this.selectedCompetition = {};
      this.selectedCompetitionId = id;
      const self = this;
      this.isLoading = true;
      this.isSubmitted = true;

      window.$.ajax({
        dataType: "json",
        type: 'get',
        contentType: "application/ld+json;",
        url: '/api/competitions/' + id,
        success: function (data) {
          if (data.projectRules !== null) {
            //self.validationRules = data.projectRules;
            self.checkErrors();
          } else {
            self.isLoading = false;
          }
        },
        error: function (data) {
          console.log(data);
        }
      });
    },

    onSubmit() {
      this.checkErrors();
      this.isSubmitted = true;
      const self = this;
      if (self.errors.length === 0) {
        axios.patch('/api/projects/' + window.projectId,
          {
            'isPublished': true
          },
          {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/merge-patch+json',
            }
          }
        ).then(() => {
          //console.log(response);
          if (self.isSubmitted) {
            self.checkErrors();
          }
          self.getData()
        }).catch(error => {
          console.log(error);
          alert('Ошибка получения данных')
        });
      }
    },
    isRequired(value) {
      return !(value && value.trim());
    },
    isFieldRequired(fieldName) {
      let res = false;
      this.validationRules.forEach(function (field) {
        if (
          (field.fieldName === fieldName || field?.altFieldName === fieldName)
          && field.isRequired) {
          res = true;
        }
      });
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if (
            (field.fieldName === fieldName || field?.altFieldName === fieldName)
            && field.isRequired) {
            res = true;
          }
        });
      }
      return res;
    },
    isValidUrl(value) {
      if (!value) {
        return true
      }
      var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
          '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
      if (!urlPattern.test(String(value).toLowerCase())) {
        return 'Укажите полный адрес сайта в формате https://site.ru'
      }
      return true;
    },
    isFieldVisible(fieldName) {
      let res = true;
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if ((field.fieldName === fieldName || field?.altFieldName === fieldName) && !field.isRequired && !field.isNeeded) {
            res = false;
          }
        });
      }
      return res;
    },
  },

}
</script>

<style scoped>
.modal {
  display: block;
  width: 80%;
  max-width: 950px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 20px;
  text-align: center;
  margin: 30px auto 30px;
  position: relative;
}

.category_select_active {
  font-weight: bold;
}

.close_button {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 20px;
  cursor: pointer;
}

.vue-universal-modal {
  z-index: 111;
}

.errors-block {
  color: red;
  border: 1px solid #999;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
}

.lds-default {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: scale(0.5);
  text-align: center;
}

.lds-default div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #000;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}

.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}

.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}

.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}

.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}

.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}

.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}

.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}

.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}

.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}

.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}

.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

.competition_wrapper {
  position: relative;
  max-width: 355px;
}

.modal .columns.is-multiline {
  justify-content: center;
}

.modal .columns.is-multiline .col1 {
  margin-right: 50px;
  margin-bottom: 70px;
}

.competition-info {
  background: #FEF4E5;
  padding: 20px;
}

.competition-image-wrapper {
  position: relative;
  display: flex;
  border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
  font-size: 21px;
}

.vue-universal-modal {
  z-index: 111;
}

.competition-title__wrapper {
  line-height: 1;
}

.competition-title {
  font-size: 16px;
}

.category_select {
  font-size: 18px;
}

.content_block .tabs ul {
  align-items: inherit;
}

.content_block .tabs ul li {
  display: flex;
}

.category_select:hover {
  color: #F69F22;
  cursor: pointer;
}

.help_text {
  margin-bottom: 30px;
  margin-top: 30px;
  font-style: italic;
  color: #8F9194;
  cursor: pointer;
}

.help_text svg {
  margin-right: 10px;
}
.modal_question {
  text-align: left;
  font-size: 16px;
}
@keyframes lds-default {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>
